/** Valeurs de repli si l’API publique n’est pas disponible */
export const siteContact = {
  phone: process.env.REACT_APP_SITE_PHONE || '+216 XX XXX XXX',
  phoneHref: process.env.REACT_APP_SITE_PHONE_HREF || 'tel:+21600000000',
  email: process.env.REACT_APP_SITE_EMAIL || 'contact@liberty.tn',
  social: {
    facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://facebook.com/',
    instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://instagram.com/',
    tiktok: process.env.REACT_APP_SOCIAL_TIKTOK || 'https://tiktok.com/',
  },
};

export function phoneToTelHref(phone) {
  const raw = String(phone || '').trim();
  if (!raw) return '';

  const cleaned = raw.replace(/[^\d+]/g, '');
  if (!cleaned) return '';

  if (cleaned.startsWith('+')) return `tel:${cleaned}`;
  if (cleaned.startsWith('00')) return `tel:+${cleaned.slice(2)}`;
  if (cleaned.startsWith('0')) return `tel:+216${cleaned.slice(1)}`;
  if (/^[2-9]\d{7}$/.test(cleaned)) return `tel:+216${cleaned}`;

  return `tel:${cleaned}`;
}

export default siteContact;
